'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cssClasses = require('../helpers/cssClasses');

var _cssClasses2 = _interopRequireDefault(_cssClasses);

var _utils = require('../helpers/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Export overlay module as default.
 */
/**
 * Mixin: Overlay
 * -----------------------------------------------------------------------------
 * A simple mixin to toggle window overlay with escape events
 *
 * @namespace Overlay
 */
exports.default = function (config) {

  /**
   * Instance default settings.
   */
  var defaults = {
    namespace: 'overlay',
    container: 'window-overlay'
  };

  /**
   * Instance settings.
   */
  var settings = (0, _utils.extendDefaults)(defaults, config);

  /**
   * Construct window overlay element on DOM.
   */
  function constructOverlay() {
    var element = document.createElement('div');
    element.classList.add(settings.container);
    return element;
  }

  /**
   * Get window overlay element.
   */
  function getOverlay() {
    return document.querySelector('.' + settings.container);
  }

  /**
   * Open overlay and set esc events.
   */
  function open() {
    if (getOverlay()) {
      return;
    }

    render();
    setCloseEvents();
  }

  /**
   * Hide overlay and remove esc event.
   */
  function close() {
    if (!getOverlay()) {
      return;
    }

    remove();
  }

  /**
   * Render overlay after constructing DOM element.
   */
  function render() {
    var windowOverlay = constructOverlay();
    document.body.appendChild(windowOverlay);

    // Dirty way to avoid MutationObserver by using an instant timeout.
    window.setTimeout(function () {
      return windowOverlay.classList.add(_cssClasses2.default.active);
    }, 1);
    Frame.EventBus.emit('Overlay:' + settings.namespace + ':show');
  }

  /**
   * Remove overlay from DOM after transitioning out.
   */
  function remove() {
    (0, _utils.on)('transitionend', getOverlay(), function () {
      if (getOverlay()) {
        document.body.removeChild(getOverlay());
      }
    });

    getOverlay().classList.remove(_cssClasses2.default.active);
  }

  /**
   * Set close events.
   */
  function setCloseEvents() {
    (0, _utils.on)('click', getOverlay(), function () {
      return handleClickEvent();
    });
  }

  /**
   * Handle click event on overlay.
   */
  function handleClickEvent() {
    Frame.EventBus.emit('Overlay:' + settings.namespace + ':hide');
  }

  /**
   * Expose public interface.
   */
  return Object.freeze({
    open: open,
    close: close
  });
};